import { Timestamp } from "firebase/firestore";

function toDateOnly(timestamp) {
    if (!timestamp) return "";
    let date = timestamp.toDate();

    if (isNaN(date.getTime())) {
        return ""; 
    }

    return date.toISOString().split("T")[0]; // YYYY-MM-DD
};

function backToTimestamp(dateString) {
    if (!dateString) return null;
    const date = new Date(dateString + "T00:00:00");

    return Timestamp.fromDate(date);
};

export { toDateOnly, backToTimestamp };